/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData } from '../../../services/CryptoService';

/** Common Components */
import CardSection from '../../../components/ui/card/CardSection';
import FormCreator from '../../../components/finalForms/FormCreator';
import Buttons from '../../../components/ui/button/Buttons';
import RenderTabs from '../../../components/ui/tabs/RenderTabs';

/** Common Services & Data Files */
import GroupMembers from './GroupMembers';
import GroupProject from './GroupProject';

/** Configuration Files */
import { groupData } from '../config/Group.data';

/** RTK Query */
import { useAddEditGroupMutation, useLazyGetGroupManagementByIdQuery } from '../../../app/services/groupManagementAPI';
import ToastService from '../../../services/toastService/ToastService';

const EditGroupManagement = () => {
  const groupRef = useRef();
  const navigate = useNavigate();
 /* State*/
  const [groupForm, setGroupForm] = useState(groupData);
  const { id } = useParams();
  const groupId = id ? decryptUrlData(id) : 0;
  
  const [getGroupById, {
    isFetching: isGetGroupByIdFetching,
    isSuccess: isGeGroupByIdSuccess,
    data: isGetGroupByIdData,
  },] = useLazyGetGroupManagementByIdQuery();

  const [addEditGroup, {
    isSuccess: isSucessAddEditGroup,
    data: addEditGroupData,
  },] = useAddEditGroupMutation();

  const tabs = [
    {
      sMenuItemCaption: `Group Member`,
      icon: "",
      component: <GroupMembers />
    },

    {
      sMenuItemCaption: `Group Project`,
      icon: "",
      component: <GroupProject />
    }
  ]

  useEffect(() => {
    if (groupId) {
      getGroupById(groupId);
    }
  }, [groupId]);

  useEffect(() => {
    if (
      isGeGroupByIdSuccess &&
      !isGetGroupByIdFetching &&
      isGetGroupByIdData
    ) {
      if (isGetGroupByIdData) {
        let formData = { ...groupData };
        formData.initialState = {
          ...groupData.initialState,
          groupName: isGetGroupByIdData.groupName,
        };
        setGroupForm(formData);
      }
    }
  }, [isGeGroupByIdSuccess, isGetGroupByIdFetching, isGetGroupByIdData]);

  useEffect(() => {
    if (isSucessAddEditGroup && addEditGroupData) {
      ToastService.success(addEditGroupData.errorMessage);
      backToList();
    }
  }, [isSucessAddEditGroup, addEditGroupData]);

  const handleSubmit = () => {
    const GroupData = groupRef.current.getFormData();
    if (GroupData && groupId) {
      const requestUpdateData = {
        ...GroupData,
        groupId: groupId,
        groupName: GroupData?.groupName
      };
      addEditGroup(requestUpdateData);
    }
  }
  const backToList = () => {
    navigate("/admin/groups");
  };

  return (
    <div className='group-info center-top-space'>
      <CardSection
        cardTitle={`Group - ${isGetGroupByIdData?.groupName}`}>
        <form>
          <div className='row mt-0 edit-project-form'>
            <FormCreator
              config={groupForm}
              ref={groupRef} />
          </div>
        </form>

        <div className="d-flex justify-content-end">
          <Buttons
            buttonTypeClassName="dark-btn"
            buttonText="Cancel"
            onClick={backToList}
          />
          <Buttons
            buttonTypeClassName="theme-btn ml-4"
            buttonText={'Update'}
            onClick={handleSubmit}
          />
        </div>
      </CardSection>

      <div className="group-additional-section">
        <RenderTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default EditGroupManagement;
